import { useTeamChatSelector } from '@frontend/team-chat-new';

export const useChatPopup = () => {
  const openTeamChat = useTeamChatSelector((ctx) => ctx.openTeamChat);
  const openDynamicConversation = useTeamChatSelector((ctx) => ctx.openDynamicConversation);

  const handleOpenMessage = () => {
    openTeamChat();

    // Smoothing out the transition, and ensuring the modal is closed before opening the chat
    setTimeout(() => {
      openDynamicConversation(undefined);
    }, 100);
  };

  return { handleOpenMessage };
};
